import React, { useEffect, useState } from 'react';
import ResultTable from '../../../ResultTable/ResultTable'
import styled from 'styled-components'
import { Black, Shadow, WerfenColor, WerfenColorLight, White } from '../../../../Constants/ColorChart'
import { DocumentsFolder } from '../../../../Constants/AppData'
import { connect } from 'react-redux'
import { hideSearchBar, setTitleBar, } from "../../../../../actions/ui";
import isElectron from 'is-electron'
import Loader from "../../../Loader/Loader";
import { formatBytes } from "../../../../../../web/Utils/utils";
import Button from "../../../Button/Button";
import { Col, Row } from "react-bootstrap";
import Dialog from "../../../Dialog/Dialog";
import SearchIcon from "../../../Icons/Search/Search";
import ClearIcon from "../../../Icons/Delete/Delete";
import FeatherIconWrapper from "../../../Icons/FeatherIconWrapper";
import './AvailableOfflineSection.css'

let electron;

if ( isElectron () ) {
    electron = window.require ( "electron" )
}

const ipcRenderer = electron && electron.ipcRenderer;

/*
 *  @Description:   Component that renders a table with all items available offline.
 */

const StyledDiv = styled.div`
  color: ${ White };
  width: calc(94% - 60px);
  margin-right: auto;
  margin-left: 80px;
  @media screen and (min-width: 992px){
    margin-left: 280px;
    width: calc(94% - 250px);
  }
  .TableWrapper {
    width: 100%;
    width: 100%;
    margin-bottom: 3%;
    color: ${ Black };
    padding: 2%;
    border: 2px solid rgba(0,0,0,0.05);
    background-clip: padding-box;
  }
  .Search {
    position: relative;
  }
`;

const StyledButton = styled.div`
   background: ${ WerfenColor };
   display: inline-block;
   vertical-align: bottom;
   height: 50px;
   width: 50px;
`
const StyledClearButton = styled.div`
   background: transparent;
   display: inline-block;
   height: 48px;
   width: 48px;
   margin: 1px;
   position: absolute;
   right: 65px;
`

const StyledSearch = styled.input`
    border: none;
    width: 100%;
    font-size: 15pt;
    background: ${ White };
    color: ${ Black };
    padding-left: 2%;
    padding-right: 2%;
    height: 50px;
    display: inline-block;
    margin-right: 0px;
    width: calc(100% - 50px);
    outline: 0;
    border: 1px solid rgba(0, 0, 0, 0.2);
    &:focus {
        border-color: ${ Black }
    }
`

const AvailableOfflineSection = ( props ) => {
    const [ resourceData, setResourceData ] = useState ( null );
    const [ playlistData, setPlaylistData ] = useState ( null );
    const [ labelMessage, setLabelMessage ] = useState ( "" );
    const [ searchQuery, setSearchQuery ] = useState ( "" );
    const { settings } = props;
    const resourceTitle = "Offline Resources";
    const playlistTitle = "Offline Playlists";
    const resourceFields = [ "", "name", "size", "format" ];
    const playlistFields = [ "name" ];

    useEffect ( () => {
        props.hideSearchBar ();
        props.setTitleBar ( "Available Offline" );
        getContentsFromDB ();

        ipcRenderer.on ( "indexationFinished", getContentsFromDB );
        ipcRenderer.on ( 'finishedGetAllResourcesFromDB', setResources );
        ipcRenderer.on ( 'finishedGetAllPlaylistsFromDB', setPlaylists );
        ipcRenderer.on ( 'deletionFinished', getContentsFromDB );
        ipcRenderer.on ( 'updateVerifyMessage', setUpdateMessage );
        return () => {
            ipcRenderer.off ( "indexationFinished", getContentsFromDB );
            ipcRenderer.off ( 'finishedGetAllResourcesFromDB', setResources );
            ipcRenderer.off ( 'finishedGetAllPlaylistsFromDB', setPlaylists );
            ipcRenderer.off ( 'deletionFinished', getContentsFromDB );
            ipcRenderer.off ( 'updateVerifyMessage', setUpdateMessage );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    useEffect ( () => {
        if ( searchQuery === "" ) {
            getContentsFromDB ()
        }
    }, [ props.dialogVisible, props.isNetworkAvailable, labelMessage, searchQuery ] );

    const getContentsFromDB = ( event, filter ) => {
        ipcRenderer.send ( "getAllResourcesFromDB", filter );
        ipcRenderer.send ( "getAllPlaylistsFromDB", filter );
    }

    const setResources = ( event, resources ) => {
        let documentsURI = `file://${ DocumentsFolder }`;

        if ( window.location.protocol === "http:" ) {
            documentsURI = `http://localhost:9990/`
        }

        if ( resources.length > 0 ) {
            const resourcesWithoutNull = resources.filter ( item => item.id !== null )
            const lastVerifiedValues = resourcesWithoutNull.map ( item => {
                return item.lastVerified
            } );
            const data = resourcesWithoutNull.map ( resource => {
                return {
                    id: resource.id,
                    metadata: {
                        name: resource.name,
                        description: resource.description,

                        filename: resource.doc_name,
                        entityBundle: resource.entityBundle,
                        entityChanged: new Date ( resource.entityChanged ).toLocaleDateString ( "en-US" ),
                        lastVerified: Math.max ( ...lastVerifiedValues ),
                        format: resource.doc_format,
                        size: resource.size && resource.size !== "N/A" ? formatBytes ( resource.size ) : "N/A",
                        mimetype: resource.doc_format,
                        needs_attention: !resource.needs_attention
                    },
                    type: "resource",
                    saveAs: true,
                    file: `${ documentsURI }${ resource.doc_uuid }`,
                    url: `${ documentsURI }${ resource.doc_uuid }`,
                    actions: {
                        isDownloaded: true,
                    },
                    activities: {
                        canOpenInViewer: resource.doc_format === "PDF",
                        canViewDetail: resource.files_count > 1,//resourcesWithoutNull.length > 1,
                        canDelete: resource.playlist_id === null
                    },
                    contextActions: [],
                }
            } )
            // const entryForList = data[0];
            // const lastVerifiedValues = data.map ( item => item.metadata.lastVerified );

            // entryForList.metadata.lastVerified = Math.max ( ...lastVerifiedValues );
            setResourceData ( data );
        } else {
            setResourceData ( [] )
        }
    }

    const setPlaylists = ( event, playlists ) => {
        const data = playlists.map ( playlist => {
            return {
                id: playlist.id,
                metadata: {
                    name: playlist.name,
                    description: playlist.description,
                    lastVerified: playlist.last_verified,
                    entityChanged: new Date ( playlist.entity_changed ).toLocaleDateString ( "en-US" )
                },
                type: "playlist",
            }
        } )

        setPlaylistData ( data );
    }

    const setUpdateMessage = ( event, info ) => {
        switch ( info.type ) {
            case "date":
                const dateParsed = new Date ( info.data );
                const output = dateParsed.toLocaleString ();
                setLabelMessage ( `Last verified at: ${ output }` );
                return;
            case "text":
            default:
                setLabelMessage ( info.data );
                return;
        }
    }

    const handleChange = ( event ) => {
        setSearchQuery ( event.target.value );
    }

    const handleSubmit = ( filter ) => {
        getContentsFromDB ( null, filter );
    }

    const clearSearch = () => {
        setSearchQuery ( "" );
        document.querySelectorAll ( "#SearchBox" )[0].focus ();
        handleSubmit ( null );
    }

    const loading = ( resourceData === null || playlistData === null );

    if ( loading ) {
        return (
            <StyledDiv>
                <Loader
                    message="Loading offline contents"
                    primaryColor={ WerfenColor }
                    secondaryColor={ Shadow }
                    fontColor={ Black }
                    extraStyle="margin-top: 10%"
                />
            </StyledDiv>
        )
    }

    return (
        <StyledDiv>
            <div className={ "TableWrapper" }>
                <Row className={ "TableRow" }>
                    <Col xs={ 12 } md={ 6 } className={ "Search" }>
                        <StyledSearch
                            type={ "text" }
                            id={ "SearchBox" }
                            placeholder="Search"
                            value={ searchQuery }
                            background={ White }
                            color={ Black }
                            extraStyle={ "width:calc(100% - 50px); border: 1px solid " + Black }
                            onChange={ handleChange }
                            onKeyPress={ ( event ) => {
                                if ( event.key === 'Enter' ) {
                                    handleSubmit ( searchQuery )
                                }
                            } }
                        />

                        {
                            searchQuery !== "" &&
                            <StyledClearButton>
                                <FeatherIconWrapper
                                    color={ Black }
                                    width="50px"
                                    onClick={ clearSearch }
                                    iconStyle="padding: 10px;height: 50px; &:hover{ cursor: pointer }; overflow: visible!important"
                                    Icon={ ClearIcon }
                                />
                            </StyledClearButton>
                        }
                        <StyledButton>
                            <FeatherIconWrapper
                                color={ White }
                                width="50px"
                                onClick={ () =>
                                    handleSubmit ( searchQuery )
                                }
                                iconStyle="padding: 10px;height: 50px; &:hover{ cursor: pointer }; overflow: visible!important"
                                Icon={ SearchIcon }
                            />
                        </StyledButton>

                    </Col>
                    <Col xs={ 12 } md={ 6 } className={ "TableData text-end" }>
                        <span className={ "lastUpdatedLabel" }>{ labelMessage }</span>
                        {
                            props.isNetworkAvailable &&
                            // props.isServerReachable &&
                            <Button
                                background={ WerfenColorLight }
                                border={ WerfenColorLight }
                                color={ White }
                                id={ "updateChecker" }
                                text="Check for Updates"
                                display="inline-block"
                                onClick={ () => {
                                    ipcRenderer.send ( "getDownloadedItems", "items" );
                                } }
                            />
                        }
                    </Col>
                </Row>
            </div>
            {
                playlistData !== null && settings.playlistsFirst &&
                <ResultTable
                    rowWidth={ 20 }
                    title={ playlistTitle }
                    fieldsToShow={ playlistFields }
                    data={ playlistData }
                    type={ "available_offline" }
                    tableUnified={false}
                />
            }
            {
                resourceData !== null &&
                <ResultTable
                    rowWidth={ 20 }
                    title={ resourceTitle }
                    fieldsToShow={ resourceFields }
                    data={ resourceData }
                    type={ "available_offline" }
                    tableUnified={false}
                />
            }
            {
                playlistData !== null && !settings.playlistsFirst &&
                <ResultTable
                    rowWidth={ 20 }
                    title={ playlistTitle }
                    fieldsToShow={ playlistFields }
                    data={ playlistData }
                    type={ "available_offline" }
                    tableUnified={false}
                />
            }
            {
                props.dialogVisible &&
                <Dialog/>
            }
        </StyledDiv>
    )

}

const mapStateToProps = ( state ) => ( {
    settings: state.settings,
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    dialogVisible: state.ui.dialogVisible,
} )

export default connect ( mapStateToProps, {
    setTitleBar,
    hideSearchBar,
} ) ( AvailableOfflineSection );
